import { render } from "./Shoes.vue?vue&type=template&id=6fee1374"
import script from "./Shoes.vue?vue&type=script&lang=js"
export * from "./Shoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__